import { render, staticRenderFns } from "./UpdateOrderFee.vue?vue&type=template&id=29bfd9b6&scoped=true"
import script from "./UpdateOrderFee.vue?vue&type=script&lang=js"
export * from "./UpdateOrderFee.vue?vue&type=script&lang=js"
import style0 from "./UpdateOrderFee.vue?vue&type=style&index=0&id=29bfd9b6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bfd9b6",
  null
  
)

export default component.exports